import { Vector3 } from 'three';

const CHASE_OFFSET = new Vector3(0, 8, -25); // local: above 8m, behind 25m (-Z is behind since +Z is forward)
const COCKPIT_OFFSET = new Vector3(0, 1.5, 3.5); // local: pilot seat, slightly above and forward of pivot
const _desired = new Vector3();
const _fwd = new Vector3();
const _target = new Vector3();
const _up = new Vector3(0, 1, 0);

export function updateChaseCamera(camera, aircraft, dt, mode = 'chase') {
  if (mode === 'cockpit') {
    _desired.copy(COCKPIT_OFFSET).applyQuaternion(aircraft.quaternion).add(aircraft.position);
    camera.position.copy(_desired);
    _fwd.set(0, 0, 1).applyQuaternion(aircraft.quaternion);
    _target.copy(_desired).addScaledVector(_fwd, 100);
    camera.up.copy(_up);
    camera.lookAt(_target);
    return;
  }

  _desired.copy(CHASE_OFFSET).applyQuaternion(aircraft.quaternion).add(aircraft.position);

  const k = 4.0;
  const a = 1 - Math.exp(-k * dt);
  camera.position.lerp(_desired, a);
  camera.up.copy(_up);
  camera.lookAt(aircraft.position);
}
